import { FADE_STAGGER } from '@components/animations';

export function getListStaggerDuration({ count = 0, offset = 0, stagger = FADE_STAGGER }) {
    if (!count) {
        return offset;
    }

    return offset + stagger * (count - 1);
}
